export const POSTS_PAGE_SIZE = 20;
